import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { MongoDbLinkedService } from 'app/model/linkedservice/mongo-db.linkedservice';
import { MongoDbDataset } from 'app/model/dataset/mongo-db.dataset';

export const mongoDbCollectionMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(MongoDbDataset).name,
    displayName: stringResources.MongoDbCollection_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(MongoDbLinkedService).name],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-MongoDBCollection'
    },
    tableNameDisplay: stringResources.TableNameDisplay_CollectionName,
    tableNamePlural: stringResources.Collections,
    isFirstClass: true,
    category: ['NoSQL'],
    disableNew: true
};
